import { render, staticRenderFns } from "./audio.vue?vue&type=template&id=1544745e&scoped=true&"
import script from "./audio.vue?vue&type=script&lang=ts&"
export * from "./audio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1544745e",
  null
  
)

export default component.exports